<template>
    <v-container 
        :id="name" 
        class="illustrated-content d-flex align-stretch pa-0 my-10 mx-0" 
        :style="covered ? image( content ) : ''"
        fluid
    >
        <v-row class="mx-0" :class="`${ covered && imgPosition === 'right' ? 'justify-end ' : !covered ? 'my-10' : '' }`">
            <v-col 
                v-if="!$mq.phone && !covered"
                :class="`${ imgPosition !== 'right' ? 'order-first' : 'order-last' }`"
                class="content-image d-flex align-center pa-0"
                :style="!covered ? image( content ) : ''"
                cols="5"
            >
                <v-card
                    v-if="!!highlight"
                    tile
                    flat
                    color="transparent"
                    class="flex-fill"
                >
                    <v-card-title v-if="!!content.sections">
                        <h2 
                            style="width:100%;"
                            class="text-center"
                            :class="`${ covered ? textColor : content.titleColor } ${ $mq.phone ? '' : !!$mq.tablet ? 'display-1' : 'display-2' }`" 
                            v-html="content.sections.filter( x => !!x.title ).map( x => x.title ).join( ' + ' )"
                        ></h2>
                    </v-card-title >
                    <span v-else>{{content}}</span>
                </v-card>
            </v-col>
            
            <v-col 
                :cols="$mq.phone ? '12' : !covered ? '7' : '5'"
                :class="`${ $mq.phone && covered ? 'px-5 py-0 ' : 'pa-0 ' }${ covered ? '' : 'd-flex align-center ' }`"
                :style="$mq.phone && !covered ? { backgroundImage: `url(${ content.img })`, backgroundSize: 'cover', backgroundPosition: 'center' } : '' "
            >
                <div
                    v-observe-visibility="(isVisible, entry) => visibilityChanged(isVisible, entry, content)"
                    class="content-card"
                    :class="`${ $mq.phone ? 'semi-black ' : 'transparent px-10 '  }${ !covered ? 'fill-height d-flex align-center py-5 ' : 'my-10' }`"
                >
                    <v-fade-transition>
                        <v-card
                            v-if="!!content.visible"
                            tile
                            flat
                            :color="covered ? 'white-75' : 'transparent'"
                            class="flex-fill"
                            :class="covered ? 'elevation-5 px-5 py-10' : 'pa-10'"
                            :style="$mq.phone && covered ? 'margin-bottom: 33vh;' : ''"
                        >                            
                            <div
                                v-for="(section, i) in content.sections"
                                :key="`${ name }-section-${ i }`"
                                :class="i > 0 ? 'mt-5' : ''"
                                :id="!!section.id ? section.id : ''"
                            >
                                <v-card-title 
                                    v-if="section.title && ( !highlight || $mq.phone || covered )"
                                    class="d-flex"
                                    :class="`${ $mq.phone ? ' justify-center' : imgPosition === 'right' && !covered ? 'justify-end' : 'justify-start' }`"
                                >
                                    <h2 :class="`${ textColor } ${ $mq.phone ? '' : !!$mq.tablet ? 'display-1' : 'display-2' }`" v-html="section.title" />
                                </v-card-title>
                                
                                <v-card-subtitle
                                    v-if="section.subtitle"
                                    :class="`${ 
                                        textColor 
                                    } ${ 
                                        $mq.desktop ? 'display-1' : ''
                                    } ${ 
                                        $mq.phone ? ' justify-center' : imgPosition === 'right' && !covered ? 'justify-end' : 'justify-start' 
                                    }`"
                                >
                                    {{section.subtitle}}
                                </v-card-subtitle> 

                                <v-card-text 
                                    v-if="!!section.text && !!section.text.content"
                                    class="d-flex flex-column pb-0"
                                    :class="`${ $mq.phone ? ' justify-center' : imgPosition === 'right' ? 'text-right' : 'text-left' }`"
                                >
                                    <h3 
                                        v-html="section.text.title"
                                        :class="textColor"  
                                        class="mb-5" 
                                    />

                                    <div 
                                        v-for="(paragraph, i) in section.text.content" 
                                        :key="`${ name }-paragraph-${ i }` "
                                    >
                                        <p 
                                            v-if="typeof paragraph === 'string'"  
                                            v-html="paragraph"
                                            :class="textColor"
                                        />
                                    </div>
                                </v-card-text>

                                <v-card-text v-if="!!section.list" :class="textColor">
                                    <ContentLists
                                        :list="{  
                                            ...section.list, 
                                            textColor: textColor,
                                            name: name,
                                            imgPosition: imgPosition,
                                        }"
                                    />
                                </v-card-text>


                                <v-expand-transition>
                                    <div v-if="!!section.more && !!section.more.show">
                                        <div 
                                            v-for="(s, j) in section.more.sections"
                                            :key="`${ name }-list-item-${ i }-more-${ j }`"
                                        >
                                            <v-card-text 
                                                v-if="!!s.text"
                                                class="d-flex flex-column"
                                                :class="`${ $mq.phone ? ' justify-center' : imgPosition === 'right' ? 'text-right' : 'text-left' } ${ !!section.more && !!section.more.show ? 'pt-0' : '' }`"
                                            >
                                                <div v-for="(paragraph, i) in s.text" :key="`${ name }-paragraph-${ i }` ">
                                                    <p 
                                                        v-if="typeof paragraph === 'string'"  
                                                        v-html="paragraph"
                                                        :class="textColor"
                                                    ></p>                                
                                                </div>
                                            </v-card-text>

                                            <v-card-text v-if="!!s.list" :class="`${ textColor } ${ !!section.more && !!section.more.show ? 'pt-0' : '' }`">
                                                <ContentLists 
                                                    :list="{ 
                                                        ...s.list, 
                                                        textColor:textColor,
                                                        name: name,
                                                        imgPosition: imgPosition,
                                                    }"
                                                />
                                            </v-card-text>
                                            
                                            <v-card-actions 
                                                v-if="!!s.action"
                                                :class="$mq.phone ? 'justify-center' : imgPosition === 'right' ? 'justify-end' : 'justify-start'"
                                            >
                                                <router-link
                                                    class="action-link"
                                                    :to="s.action.to"
                                                >
                                                    <v-icon v-if="!!s.action.prependIcon" left>mdi-{{ s.action.prependIcon }}</v-icon>
                                                    {{ s.action.title }}
                                                </router-link>
                                            </v-card-actions>
                                        </div>                                        
                                    </div>
                                </v-expand-transition>

                                <div
                                    v-if="!!section.more"
                                    class="d-flex justify-center"
                                >
                                    <v-btn
                                        block
                                        tile
                                        elevation="0"
                                        x-small
                                        @click.prevent="toggleMore( section )"
                                        color="transparent"
                                    >
                                        <v-icon :class="!!section.more.show ? 'flipped' : ''" class="show-more-btn custom-gray-text">mdi-chevron-down</v-icon>
                                    </v-btn>
                                </div>

                                <v-card-actions 
                                    v-if="!!section.action"
                                    :class="$mq.phone ? 'justify-center' : imgPosition === 'right' ? 'justify-end' : 'justify-start'"
                                >
                                    <CTABtn :item="section.action" class="mt-5"/>
                                </v-card-actions>
                            </div>
                        </v-card>   
                    </v-fade-transition>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import ContentLists from '@/components/ContentLists'
import CTABtn from '@/components/CTABtn'

export default {
    name: 'IllustratedContent',
    props: [
        'name',
        'imgPosition',
        'highlight',
        'cover',
        'dark',
    ],
    components: {
        CTABtn,
        ContentLists
    },
    data() {
        return {
            contents: {
                about: {
                    visible: false,
                    img: require(`@/assets/img/kid-${ !!this.$mq.phone ? 'sm' : 'md' }.jpg`),
                    sections: [
                        {
                            title: `À propos de ${ process.env.VUE_APP_ORG }`,
                            subtitle: null,
                            text: {
                                content: [
                                    `Entreprise québécoise spécialisés dans la technique du Pisé stabilisé. Nous réalisons 
                                    du mobilier paysager ainsi que des murs esthétiques et durables. Avec notre technique du 
                                    pisé stabilisé, nous sommes en mesure d’ériger des murs pour la construction de bâtiments 
                                    de tous genres ainsi que des éléments pour l’aménagement paysager.`,

                                    `Notre mission; réduire l’empreinte écologique du béton lors de la fabrication de murs 
                                    pour la construction de bâtiments et d’éléments pour l’aménagement paysager.`,
                                    
                                    `Plus écologique, plus esthétique, tout en étant aussi solide et durable qu’un béton 
                                    standard, voilà ce que Projet ERA vise.`,
                                ],
                            },
                            action: {
                                prependIcon: `message-outline`,
                                title: 'Parlez-nous de votre projet',
                                to: {
                                    path: '/',
                                    hash: '#contact',
                                },
                            },
                        },
                    ],     
                },
                structures: {
                    visible: false,
                    img: require(`@/assets/img/test-bg-${ !!this.$mq.phone ? 'sm' : !!this.$mq.tablet ? 'md' : 'lg' }.jpg`),
                    titleColor: 'custom-white-text',
                    sections: [
                        {
                            title: `Structures`,
                            subtitle: null,
                            text: {
                                title: `Pour l'efficacité et la durabilité`,
                                content: [
                                    `Fabrication de murs isolés ou non pour la construction de bâtiment, de structure pour 
                                    le support de différents objets ou de murs antibruit.`,
                                    
                                    `Les murs non isolés sont fabriqués en atelier avec des mélanges testés et dans des 
                                    conditions contrôlées. Après un mois de cure dans l’atelier, les murs sont déplacés sur 
                                    le site pour être installés. L’installation est rapide et facile.`,
                                ],
                            },
                        },
                    ],                        
                },
                services: {
                    visible: false,
                    img: require(`@/assets/img/agrégat-compacté${ !!this.$mq.phone ? '-sm' : '' }.jpg`),
                    titleColor: 'custom-white-text',
                    sections: [
                        {
                            title: `Services offerts`,
                            subtitle: null,
                            list: {
                                title: `Notre expertise`,
                                items: [
                                    `Mobilier sur mesure en pisé stabilisé`,

                                    `Murs sur mesure en pisé stabilisé`,

                                    `Conception de plans résidentiels par un technologue senior en architecture`,

                                    `Suivi de chantier pour le démarrage d’une construction en Pisé stabilisé pour les 
                                    autoconstructeurs`,

                                    `Aide à la production de plans pour le secteur commercial, institutionnel, industriel 
                                    et résidentiel pour d’autres architectes et/ou bureaux d’architectes`,

                                    `Formation sur le Pisé stabilisé (à venir)`,
                                ]
                            },
                            action: {
                                prependIcon: `message-outline`,
                                title: 'Contactez un représentant',
                                to: {
                                    path: '/',
                                    hash: '#contact',
                                },
                            },
                        }
                    ]
                },
                'pisé-stabilisé': {
                    visible: false,
                    img: require(`@/assets/img/ambiance-2-lg.jpg`),
                    titleColor: 'custom-white-text',
                    sections: [
                        {
                            title: `Pisé stabilisé`,
                            subtitle: null,
                            text: {
                                title: `Qu’est-ce que le Pisé stabilisé?`,
                                content: [
                                    `L’origine de cette technique remonte à plus de 10 000 ans. Au tout début, pour faire 
                                    un mur en Pisé, un mélange de terre argileuse légèrement humide était fait. Une certaine 
                                    quantité de mélange était introduite dans un coffrage puis compactée. Le procédé était 
                                    reproduit couche par couche jusqu’au sommet du mur. Dans certains pays la technique est 
                                    restée inchangée tandis que dans d’autres, comme au Canada, l’argile a été remplacée par 
                                    un faible pourcentage de ciment, variant de 5 à 10%, afin de stabiliser le mélange, d’où 
                                    le nom de Pisé stabilisé.`,
                                    
                                    `Avec l’étude des agrégats (sable, criblure et pierre), une augmentation significative 
                                    de la résistance à la compression a été notée, passant de 5MPa à 20MPa. Ce qui a permis 
                                    de réduire l’épaisseur du produit en plus d’accroître sa durabilité. En combinant la 
                                    technique du Pisé stabilisé et l’étude des agrégats, une diminution du ciment et de l’eau 
                                    potable permettent d’être plus propre et plus écologique qu’un béton traditionnel.`,
                                    
                                    `Projet ERA s’efforce de réduire sa quantité de ciment afin d’être encore moins polluant 
                                    et d’utiliser le plus de produits locaux.`,
                                ],
                            },
                            /* more: {
                                show: false,
                                sections: [
                                    {
                                        text: [
                                            `De plus, tous nos produits sont récupérables en totalité. Au terme de leur 
                                            utilisation, ils peuvent être brisés et reconcassés afin d’être réutilisés pour 
                                            d’autre mélanges.`,
                                        ],
                                    },
                                    {
                                        list: {
                                            title: `Utilisé dans la construction, le pisé stabilisé offre de nombreux avantages:`,
                                            items: [
                                                `Aide à gérer l’humidité dans la bâtisse`,
                                                `Aucun COV (composés organiques volatils)`,
                                                `Muret (clôture)`,
                                                `Réduction des champs électromagnétiques pouvant être diminués jusqu’à 97% selon certaines conceptions testées`,
                                                `Conception anti-vermine et anti rongeur`,
                                                `Résistance élevée à la moisissure`,
                                                `Résistance élevée à l’efflorescence`,
                                                `Facteur élevé d'isolation acoustique`,
                                                `Construction durable avec des coûts d’entretien très bas (un lavage à l’eau sous pression à tous les 5 ou 10 ans pour l’extérieur)`,
                                                `Réduction des coûts pour le chauffage et la climatisation`,
                                                `Réduction des coûts d’assurances dû au propriétés ignifuges`,
                                                `Augmentation de la rapidité de construction`,
                                            ]
                                        },
                                        action: {
                                            prependIcon: `information-outline`,
                                            title: 'Renseignez-vous sur les formations offertes',
                                            to: {
                                                path: '/',
                                                hash: '#contact',
                                            },
                                        },
                                    },
                                ],
                            },  */
                        },                        
                    ],    
                },
                advantages: {
                    visible: false,
                    img: require(`@/assets/img/house-${ !!this.$mq.desktop ? 'lg' : 'md' }.jpg`),
                    titleColor: 'custom-white-text',
                    sections: [
                        {
                            title: `Avantages`,
                            subtitle: null,
                            list: {
                                title: `Quels sont les avantages de construire en Pisé stabilisé?`,
                                items: [
                                    `Construction solide et durable`,

                                    `Pratiquement sans entretien`,

                                    `De part sa masse, une économie potentiel sur les coûts de chauffage et de climatisation`,

                                    `Sans COV`,

                                    `Réduction des coûts d'assurances`,

                                    `Très haut facteur d'isolation acoustique`,

                                    `Gestion de l’humidité`,

                                    `Réduction des champs électromagnétique`,

                                    `100% recyclable`,

                                    `Anti-vermine et anti-insecte`,
                                ]
                            },
                        }
                    ]
                },
                upcoming: {
                    visible: false,
                    img: require(`@/assets/img/laptop-${ !!this.$mq.phone ? 'sm' : !!this.$mq.tablet ? 'md' : 'lg' }.jpg`),
                    position: 'bottom',
                    sections: [
                        {
                            title: null,
                            subtitle: `À venir sur notre site web`,
                            list: {
                                title: `De nouveaux modèles de mobilier tel que:`,
                                items: [
                                    `Foyer extérieur à bois`,
                                    `Foyer extérieur au gaz`,
                                    `Muret (clôture)`,
                                    `Structures préfabriquées`
                                ]
                            },
                        },
                        {
                            id: 'media-releases',
                            title: null,
                            subtitle: `À consulter aussi`,
                            list: {
                                items: [
                                    `<a href="https://maisonsaine.ca/bioconstruction/les-murs-de-terre-pour-le-confort-et-la-sante.html" target="_blank" title="Maison Saine">On parle de nous dans le magazine Maison Saine</a>`
                                ]
                            },
                        },
                    ],     
                }
            },
        }
    },
    computed: {
        content() { 
            return this.contents[ this.name ] 
        },
        textColor() {
            return !!this.covered || !this.$mq.phone ? 'custom-gray-text' : 'custom-white-text'
        },
        covered() { return this.cover !== undefined }
    },
    methods: {    
        run(method, params = null) {
            if(typeof this[method] === 'function') {
                !!params ? this[method](params) : this[method]()
            }
            else {
                this.$emit('run', method, params)
            }
        },
        toggleMore( section ) {
            section.more.show = !section.more.show
        },
        visibilityChanged( isVisible, entry, content ) {
            if( !!entry.isIntersecting ) setTimeout( function() { content.visible = true }, 250 )
        },
        image( content ) {
            return { 
                backgroundImage: `url(${ content.img })`, 
                backgroundSize: `${ !!content.size ? content.size : 'cover' }`, 
                backgroundPosition: `${ !!content.position ? content.position : 'center' }` 
            }
        },
    },
}
</script>

<style lang="scss">    
.illustrated-content {
    min-height: 50vh;
}

.content-image {
    background-position: center;
}

.v-card__title > * {
    word-break: normal;
}

.content-card {
    width: 100%;
    transition-duration: 1s;
}

.show-more-btn {
    transition: all 0.25s;
}

.flipped {
    -ms-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
}
</style>
